import React from 'react';
import styles from './style.less';

const EmptyRecord = ({
  text = '暂无记录', // string/reactNode
  img = 'nothing.png',
  imgSize = 'small',
  style = {},
  className,
  children,
  showTryAgain = false,
  onTryAgain,
  imgClass,
}) => {
  const reg = /^https?/gi;
  return (
    <div className={`${styles.emptyWrap} ${className}`} style={{ ...style }}>
      <div className={styles.emptyImg}>
        <img
          className={`${styles[`${imgSize}`]} ${imgClass}`}
          src={reg.test(img) ? img : require(`@/assets/images/${img}`)}
          alt="empty"
        />
      </div>
      <div className={styles.emptyText}>
        {text}
        {children}
        {showTryAgain && (
          <p className={styles.showAgain} onClick={onTryAgain}>
            请点击重试
          </p>
        )}
      </div>
    </div>
  );
};

export default EmptyRecord;
